export function chunkArray(array, chunkSize) {
    return Array.from({ length: Math.ceil(array.length / chunkSize) }, (_, index) =>
        array.slice(index * chunkSize, (index + 1) * chunkSize)
    );
}

export function getOrderListHtml(data, lineValues, boxValues, index, generalData, divRefs) {

    function formatDate(dateStr) {
        const date = new Date(dateStr);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }

    const updatedDate = formatDate(generalData.formData.estimatedDeliveryDate);

    // className="h-[793px] w-[1122px] relative"
    // style={{ position: "fixed", left: "-9999px"}}
    // ref={(ref) => (divRefs.current[index] = ref)}
    // eslint-disable-next-line no-return-assign, no-param-reassign
    return <div className="p-4 h-[1122px] w-[793px] relative text-[11px]" ref={(ref) => (divRefs.current[index] = ref)} style={{ position: "fixed", left: "-9999px"}}>
        <div className="flex flex-row w-full justify-between pt-8">
            <div className="flex flex-col w-3/12 items-center justify-start p-1">
                <img src="images/login_logo_image_black_text.png" alt="Viracon Logo" className="w-1/2 h-auto" />
            </div>
            {/* 1st Ends */}
            <div className="flex flex-row w-4/12">
                {/* Left Column */}
                <div className="flex flex-col w-3/6">
                    <span className="font-semibold">Order #</span>
                    <span>{generalData.orderId} {generalData.isRevised ? 'R' : ''}</span>
                    <span>&nbsp;</span>
                    <span className="font-semibold">Est. Delivery Date</span>
                    <span>{updatedDate}</span>
                    <span>&nbsp;</span>
                </div>

                {/* Right Column */}
                <div className="flex flex-col w-3/6 break-words">
                    <span>{generalData.formData.ownerName}</span>
                    <span>PH: {generalData.formData.ownerPhone}</span>
                    <span>&nbsp;</span>
                    <span className="font-semibold">Field Rep</span>
                    <span>{generalData.formData.salesTerritory}</span>
                    <span>{generalData.formData.territoryEmail}</span>
                </div>
            </div>
            {/* 2nd Ends */}
            <div className="flex flex-row w-5/12 border-2 border-[#0078c1] p-1">
                {/* Left Column */}
                <div className="flex flex-col w-1/2 space-y-1 break-words">
                    <span className="font-semibold">Ship to</span>
                    <span>{generalData.formData.ShipToCustomerName ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.shipmentAddress ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.shipmentAddress2 ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.shipmentCity} / {generalData.formData.shipmentState} / {generalData.formData.shipmentPostcode} / {generalData.formData.shipmentDestination === 'International' ? generalData.formData.shipmentCountry : 'USA'}</span>
                    <span>{generalData.formData.shipToContactName ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.shipToCustomerPhone ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.shipToContactEmail ?? <h2>&nbsp;</h2>}</span>
                </div>

                {/* Right Column */}
                <div className="flex flex-col w-1/2 space-y-1 break-words">
                    <span className="font-semibold">Order By</span>
                    <span>{generalData.formData.customerName ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.address1 ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.address2 ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.city} / {generalData.formData.state} / {generalData.formData.postcode} / {generalData.formData.destination === 'International' ? generalData.formData.country : 'USA'}</span>
                    <span>{generalData.formData.contactName ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.customerPhone ?? <h2>&nbsp;</h2>}</span>
                    <span>{generalData.formData.contactEmail ?? <h2>&nbsp;</h2>}</span>
                </div>
            </div>
            {/* 3rd Ends */}
        </div>
        <hr className="h-px my-2 bg-[#0078c1] border-2 border-[#0078c1]" />
        <div className="flex flex-row w-full pb-2">
            <div className="flex flex-col">
                <h2><span className="font-semibold">Order Note:</span>{generalData.formData.note}</h2>
            </div>
        </div>
        <hr className="h-px my-2 bg-[#0078c1] border-2 border-[#0078c1]" />
        <div className="flex flex-row w-full justify-between">
            <div className="flex flex-col w-1/3">
                <h2><span className="font-semibold">Job Name:</span>{generalData.formData.projectName}</h2>
            </div>
            <div className="flex flex-col w-1/3">
                <h2><span className="font-semibold">Job Location:</span>{generalData.formData.productLocation}</h2>
            </div>
            <div className="flex flex-col w-1/3" />
        </div>
        {data.map((item, itemIndex) => (
            <div className="pt-2">
                <table className="min-w-full bg-white min-h-44">
                    <thead>
                    <tr className="text-left">
                        <th className="px-4 py-2">Line #</th>
                        <th className="px-4 py-2">Quantity</th>
                        <th className="px-4 py-2">Size</th>
                        <th className="px-4 py-2">Description</th>
                        <th className="px-4 py-2">Glass Type</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="border-2 border-blue-500 px-4 py-2 align-top w-1/12">{lineValues.length > 0 ? lineValues[index] : ((itemIndex+1) + (index * 2) )}</td>
                        <td className="border-2 border-blue-500 px-4 py-2 align-top w-1/12">{item.quantity}</td>
                        <td className="border-2 border-blue-500 px-4 py-2 align-top w-1/12">{item.sampleSize}</td>
                        <td className="border-2 border-blue-500 px-4 py-2 align-top whitespace-pre-line w-7/12">
                            <h2 className="text-start">
                                {data.isMetric && (
                                    <>
                                        <div>{item.top_line_metric}</div>
                                        {item.spec_metric.map((desc) => (
                                            <div>{desc}</div>
                                        ))}
                                    </>
                                )}
                                {!data.isMetric && (
                                    <>
                                        <div>{item.top_line_imp}</div>
                                        {item.spec_imp.map((desc) => (
                                            <div>{desc}</div>
                                        ))}
                                    </>
                                )}
                            </h2>
                        </td>
                        <td className="border-2 border-blue-500 px-4 py-2 align-top w-2/12">{item.family !== 'N/A' ? item.family : ''}</td>
                    </tr>
                    </tbody>
                </table>
                <div className="flex flex-row w-full justify-between">
                    <div className="flex flex-col w-1/6 bg-[#f4f4f4]">
                        <span className="font-semibold">Drawing #</span>
                        <span>{item.drawing !== 'N/A' ? item.drawing : ''}</span>
                    </div>
                    <div className="flex flex-col w-5/6 bg-[#f4f4f4] ml-2">
                        <span className="font-semibold">Notes</span>
                        <span>{item.note !== 'N/A' ? item.note : ''}</span>
                    </div>
                </div>
            </div>
        ))}
    </div>
}